module.exports = "<p class='footer'>\n  <img class='image' src='../../assets/ODDK_Logo.jpg'/>\n</p>\n"